let List = {
    init: function () {
        if ($('body.list').length) {
            this.bind();
        }
    },

    bind: function () {
        this.displayListDetails();
        this.adminListFilters();
        this.activateDefaultEntity();
    },

    displayListDetails() {
        $(document).on('click', '.display-list-details', function () {
            const type = $(this).data('type');
            const id = $(this).data('id');
            const country = $(this).data('country');


            $.get('/api/list/get-item/' + type + '/' + id + '?country=' + country, response => {
                if (response.data.success) {
                    $('#responseContainer').html(response.data.html);

                    // Run the visibility logic after content is loaded
                    const msmeElement = document.querySelector('#msmeOperatorsNumber');
                    if (msmeElement) {
                        const msmeValue = parseInt(msmeElement.textContent);
                        const criteriaMsme = document.querySelector('#criteriaMSME');
                        const benefitsMsme = document.querySelector('#benefitsMSME');
                        const show = msmeValue > 0;

                        if (criteriaMsme) criteriaMsme.style.display = show ? '' : 'none';
                        if (benefitsMsme) benefitsMsme.style.display = show ? '' : 'none';
                    }
                }
            });
        });
    },

    adminListFilters() {
        $(document).on('change', '#adminListFilters', function () {
            $(this).submit();
        })
    },

    activateDefaultEntity() {
        let type = window.entityType;
        let id = window.entityId;

        if (type && id) {
            $('a[data-type=' + type + '][data-id=' + id + ']').click();
        }
    }
};


$().ready(() => {
    window.List = List;
    window.List.init();
});
